/** Category-badge colors for the product card, matching the Claude Design mockup palette. */
const CATEGORY_BADGE_COLORS: Record<string, { bg: string; text: string }> = {
  GD: { bg: "#E7F5FC", text: "#0088C4" },
  WEB: { bg: "#FFF3E0", text: "#C0630A" },
  DE: { bg: "#E8F6EC", text: "#009D48" },
  IMP: { bg: "#FDEEEE", text: "#D64545" },
  GDEXB: { bg: "#F1EAF9", text: "#5C3984" },
  IMPEXB: { bg: "#F1EAF9", text: "#5C3984" },
};

const DEFAULT_BADGE_COLOR = { bg: "#F4F6F7", text: "#75767A" };

/** Badge background/text color for a product's category chip; falls back to a neutral gray. */
export function categoryBadgeColors(category: string): { bg: string; text: string } {
  return CATEGORY_BADGE_COLORS[category] ?? DEFAULT_BADGE_COLOR;
}
